// GalleryThree.jsx
import React from 'react';
// Зургийн зам тань зөв гэж үзэв (assets folder тань src дотор байгаа эсэхийг шалгаарай)
import gallery1 from '../../assets/gallery1.png';
import gallery2 from '../../assets/gallery2.png';
import gallery3 from '../../assets/gallery3.png';

const cardData = [
  {
    img: gallery1, // Хаалт {} -ыг авсан
    title: 'Lorem ipsum dolor sit amet',
    excerpt:
      'Lorem ipsum dolor sit amet consectetur. Et quam rhoncus enim nec ultricies blandit. Habitasse Lorem ipsum dolor sit amet...',
  },
  {
    img: gallery2, // Хаалт {} -ыг авсан
    title: 'Lorem ipsum dolor sit amet consectetur.',
    excerpt:
      'Lorem ipsum dolor sit amet consectetur. Enim lectus quam rhoncus enim nec ultricies. Habitasse Lorem ipsum dolor sit amet...',
  },
  {
    img: gallery3, // Хаалт {} -ыг авсан
    title: 'Lorem ipsum dolor sit amet consectetur. Diam gravida!',
    excerpt:
      'Lorem ipsum dolor sit amet consectetur. Et quam rhoncus enim nec ultricies. Habitasse Lorem ipsum dolor sit amet...',
  },
];

export default function ImageGallery() {
  return (
    <section className="w-full bg-white text-stone-800">
      <div className="mx-auto max-w-[1920px] px-8 py-16">
        {/* Big centered heading */}
        <h2
          className="text-center uppercase tracking-wider"
          style={{ fontFamily: 'serif', fontSize: '40px', letterSpacing: '3px' }}
        >
          Gifted by nature. Created by Bodios
        </h2>

        {/* thin divider */}
        <div className="mt-8 border-t border-stone-300" />

        {/* cards row */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-10 max-w-[1270px] mx-auto">
          {cardData.map((c, i) => (
            <article key={i} className="flex flex-col items-start">
              <div className="bg-stone-100 overflow-hidden shadow-none">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full object-cover grayscale-[80%] contrast-95 max-w-[390px] max-h-[270px]"
                  loading="lazy"
                />
              </div>

              <h3 className="mt-6 text-sm font-semibold text-stone-800">
                {c.title}
              </h3>

              <p className="mt-3 text-xs text-stone-600 leading-relaxed">
                {c.excerpt}
              </p>

              <a
                href="#"
                className="mt-4 text-xs font-medium text-stone-800 underline decoration-stone-800/30 hover:decoration-stone-800"
              >
                Read more
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}